export class MauzaModel {
    public mauzaId: number;
    public mauzaName: string;
 }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/mauza/mauza.model.ts